<template>
  <div>
    <div class="description">
      Для подписания договора на оказание услуг
    </div>
    <div v-if="documents.length === 0">{{ emptyText }}</div>
    <div class="documents_list">
      <div class="document_item" v-for="document in documents"
           :key="document.id"
      >
        <div class="document_data">
          <div class="document_name">
            {{ document.name }}
          </div>
          <div class="document_info_container">
            <div class="document_url">
              <a :href="document.url" target="_blank">Открыть PDF</a>
            </div>
            <div class="document_updated_at">
              Дата размещения: {{ formatFromUnix(document.created_at) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    documents: Array,
    emptyText: String,
  },
  emptyText: {
    type: String,
    default: 'Документы отсутствуют'
  },
  methods: {
    formatFromUnix(timestamp) {
      if (!timestamp) return 'Неизвестно';
      const date = new Date(timestamp * 1000);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    }
  }
}
</script>